if(typeof window.FS === "undefined") {window.FS = {};}
// Assembly: globals
(function(window, document, FS, undefined) {

  /*
   * Included File: locale.js
   */
  if (typeof FS === "undefined") {

    FS = {};

  }

  /**

    * Return the current language of the page. For backwards compatibility this

    * is a function instead of a property.

    */

  FS.simpleLocale = FS.simpleLocale || function () {

    return document.documentElement.getAttribute('lang') || 'en';

  };

  /*
   * Included File: fetch.js
   */
  if (typeof FS === "undefined") {
    FS = {};
  }
  /**
   * This is a small fetch wrapper that respects the headers, status redirects and a flag from fetch defaults.
   * @property {object} headers Key value pairs of headers to apply by default.
   * @property {object} statusCallbacks Key value pairs of the form key=status code, value = callback
   */
  FS.fetchDefaults = FS.fetchDefaults || {
    headers: {
      "Accept": 'application/json',
      "Content-Type": 'application/json',
      "Accept-language": FS.simpleLocale()
    },
    addHeaderValue: function (header, value) {
      const existingValues = FS.fetchDefaults.headers[header];
      if (existingValues) {
        FS.fetchDefaults.headers[header] = existingValues + "," + value;
      }  else {
        FS.fetchDefaults.headers[header] = value;
      }
    },
    credentials: "same-origin",
    statusCallbacks: {
      401: function () {
        //Sunset of the boolean check when everyone updates to snow with routeRequiredUser Set.
        if (typeof FS.routeRequiresUser !== "boolean" || FS.routeRequiresUser) {
          window.location.reload();
        } else {
          new Error(`Call to ${res.url} failed with a 401 unauthorized from a page that doesn't require auth.`)
        }
      }
    }
  };

  /**
   * @param {string} url             The path to the resource you are fetching
   * @param {Object} fetchInit       The init object in JSON format from fetch api. This is where you can do 1 time overwrites of headers as well.
   * @param {Object} fsFetchOptions  This is where one time status options that can be applied with the same form as fetch defaults.
   *
   * fsFetchOptionsEx = {
   *    preProcessingCallback: function(fetchInit) { return fetchInit },
   *    postProcessingCallback: function(res) { return Promise.resolve(res) },
   *    statusCallbacks: { // overrides the defaults
   *      404: function () {//do something on all 404 responses.},
   *      500: function() {//do 500 stuff},
   *    },
   *
   ******** there are no global overrides for these to keep components from having to handel complex response patterns.
   *    doNotThrowOnBadStatus: false, // Only set this to true if you want a success on 400+ status codes. The only time it throws otherwise is on network errors.
   *    doNotConvertToJson: false // set this to true if you want the full res stream passed on response objects.
   * }
   *
   *
   */
  FS.fetch = FS.fetch || function (url, fetchInit, fsFetchOptions) {
    if (!FS.fetchDefaults.headers.Authorization) {
      if (FS.User) {
        FS.fetchDefaults.headers.Authorization = FS.User.sessionId ? 'Bearer ' + FS.User.sessionId : null;
      } else {
        FS.fetchDefaults.headers.Authorization = null;
      }
    }
    if (!fsFetchOptions) {
      fsFetchOptions = {};
    }
    if (!fetchInit) {
      fetchInit = {};
    }
    var preProcessor = fsFetchOptions.preProcessingCallback || fetchInit.preProcessingCallback || undefined;
    if (preProcessor) fetchInit = preProcessor(fetchInit);

    fetchInit.method = fetchInit.method || 'get';
    fetchInit.cache = fetchInit.cache || 'default';

    fetchInit.credentials = fetchInit.credentials || FS.fetchDefaults.credentials;
    fetchInit.headers = createHeadersWithDefaults();
    var options = Object.assign({}, fetchInit, fsFetchOptions);
    var statusCallbacks = Object.assign({}, FS.fetchDefaults.statusCallbacks, options.statusCallbacks);

    var throwOnBadStatus = !options.doNotThrowOnBadStatus;
    var convertToJson = !options.doNotConvertToJson;
    return fetch(url, fetchInit).then(function (res) {
      if (statusCallbacks[res.status]) {
        return convertToJson ? statusCallbacks[res.status](convertToJsonOrReturnOriginalRes(res)) : statusCallbacks[res.status](res);
      }
      if (!res.ok && throwOnBadStatus) {
        var error = new Error('fetch call failed with status ' + res.status);
        error.response = res;
        throw error;
      }
      res = convertToJson ? convertToJsonOrReturnOriginalRes(res) : res;
      return options.postProcessingCallback ? options.postProcessingCallback(res) : res;
    });

    function convertToJsonOrReturnOriginalRes(resp) {
      // handle empty body
      var originalRes = resp;
      return resp.json()
        .catch(function () {
          return originalRes;
        })
    }


    function isHeadersObject(checkHeader) {
      return (checkHeader.has && checkHeader.get && checkHeader.set);
    }

    /**
     *  Force the input headers to be a Headers object for fetch
     *
     * @param fetchInitHeaders Input headers optionally supplied to fetch
     */
    function correctInputHeaders(fetchInitHeaders) {
      var headers = fetchInitHeaders;
      if (headers && !isHeadersObject(headers)) {
        headers = new Headers();
        Object.keys(fetchInitHeaders).forEach(function (key) {
          headers.set(key, fetchInitHeaders[key])
        });
      }
      return headers || new Headers();
    }

    function createHeadersWithDefaults() {
      var headers = correctInputHeaders(fetchInit.headers);
      Object.keys(FS.fetchDefaults.headers).forEach(function (key) {
        if (!headers.has(key)) {

          // Content-Type should only be set when body is being passed
          if (key !== 'Content-Type' || (fetchInit && fetchInit.body)) {
            headers.set(key, FS.fetchDefaults.headers[key]);
          }

        }
      });
      return headers;
    }
  };


  /*
   * Included File: cookie.js
   */
  if (typeof FS === "undefined") {
    FS = {};
  }

  FS.Cookie = FS.Cookie || {

    /**
      * @function - setCookie sets a cookie with the specified parameters--path, expires and domain are optional params. If expires is null then cookie will expire with the session.
      * @param {string} cookieID - The name of the cookie to be stored
      * @param {string} cValue - The value to be stored in the cookie
      * @param {string} [path] - The path of the cookie to be set. Defaults to "/"
      * @param {Date|string|integer} [expires] - Either a date object or date string specifying the cookie Expires, or an integer specifying the Max-Age in seconds from now. Not providing this parameter will result in the creation of a session cookie
      * @param {string} [domain] - The domain of the cookie to be set. Defaults to the current domain
      * @returns - nothing
      * @calls - document.cookie()
    */
    setCookie: function(cookieID, cValue, path, expires, domain) {
      var expDate = expires || null;
      var cPath = path || null;
      var domain = domain || null;
      var NameOfCookie = cookieID;
      var cookieString = NameOfCookie + "=" + escape(cValue);
      if(cPath){
        cookieString += ";path=" + cPath;
      }
      if(domain){
        cookieString += ";domain=" + domain;
      }
      if(expDate){
        if(typeof(expDate) === 'number') {
          cookieString += ";max-age=" + expDate;
        } else {
          if(typeof(expDate) !== 'string') {
            expDate = expDate.toUTCString();
          }
          cookieString += ";expires=" + expDate;
        }
      }
      document.cookie = cookieString;
    },

    /* Delete an existing cookie */
    unsetCookie: function(cookieID, path, domain) {
      FS.Cookie.setCookie(cookieID, null, path, "Thu, 01-Jan-1970 00:00:01 GMT", domain);
    },

    /* Returns a named cookie if available */
    getCookie: function(cookieID) {
      var dc = document.cookie, prefix = cookieID + "=", begin = dc.indexOf("; " + prefix);
      if (begin == -1) {
        begin = dc.indexOf(prefix);
        if (begin !== 0)
          return null;
      }
      else
        begin += 2;
      var end = document.cookie.indexOf(";", begin);
      if (end == -1)
        end = dc.length;
      return unescape(dc.substring(begin + prefix.length, end));
    }

  };


  /*
   * Included File: dialog.js
   */
  if (typeof FS === "undefined") {
    FS = {};
  }
  if (!FS.dialog) FS.dialog = {};
  // dialog.js


  /**
   * This function will register global elements and attach a reference to them to FS.dialog
   * @param {string} elementName - The name of the element to register e.g. fs-person-card
   * @returns {undefined} - Returns void.
   */
  FS.dialog.register = function(elementName) {
    var camelCaseName = elementName.replace(/-([a-z])/g, function (g) { return g[1].toUpperCase(); });
    if (FS.dialog[camelCaseName]) {
      console.error('Attempted to create element', elementName, 'which already exists');
      return;
    }
    var element = document.createElement(elementName);
    document.body.appendChild(element)
    Object.defineProperty(FS.dialog, camelCaseName, {
      get: function() {
        return element;
      }
    })
  };


  /*
   * Included File: debug.js
   */
  if (typeof FS === "undefined") {
    FS = {};
  }

  /* Check query params for a single 'debug', or a 'debug=text1,text2' */
  var match, patt = /(?:(?:\?|\&)+)(debug\b)(?:\=?)(?:(\w,?)*)/;

  /* Set up FS.debugMode and FS.debugFilter */
  FS.debugFilter = FS.debugFilter || [];
  FS.debugMode = FS.debugMode || false;

  if (match = window.location.search.match(patt)) {
    var debugFilter = match[0].split("=")[1];

    if (debugFilter !== 'false') {
      FS.debugMode = true;
      if (debugFilter !== 'true') {
        FS.debugFilter = debugFilter ? debugFilter.split(",") : [];
      }
    }
  }

  /* FS.debug returns true if `filter` matches an item in FS.debugFilter[] */
  FS.debug = FS.debug || function(filter) {
    if (FS.debugFilter.indexOf(filter) !== -1 || FS.debugFilter.indexOf("all") !== -1) {
      return true;
    } else {
      return false;
    }
  }

  /*
   * Included File: url.js
   */
  if (typeof window.FS === "undefined") { window.FS = {}; const FS = window.FS; }


  if (!FS.URL) {
    FS.URL = {};
    // Takes a url as input, parses the querystring parameters, and returns them as an object.
    FS.URL.parseParams = function (url) {
      var parsedURL = FS.URL.parseURL(url),
        params = parsedURL.search,
        ret = {};

      //removes first char which is '?'
      params = params.substring(1, params.length);

      if (params.length === 0) {
        return {};
      }

      var params = params.split('&');
      for (var i = 0; i < params.length; i++) {
        var param = params[i].split('=', 2);
        if (param.length == 1) {
          ret[param[0]] = true;
        } else if (param.length == 2) {
          ret[param[0]] = decodeURIComponent(param[1]);
        }
      }
      return ret;
    };

    // takes a url and parses all the parts out
    FS.URL.parseURL = function (url) {
      var parser = document.createElement('a');
      parser.href = url;

      // remove trailing &
      if (parser.href.length > 0 && (parser.href[parser.href.length - 1] === '&')) {
        parser.href = parser.href.slice(0, -1);
      }

      return parser;
    };

    // Takes an object as input and returns a query string fragment without the beginning ? as would be needed in a url.
    FS.URL.toQueryString = function (params) {
      var pairs = [];
      for (var i in (params || {})) {
        pairs.push(encodeURIComponent(i) + '=' + encodeURIComponent(params[i]));
      }

      if (pairs.length === 0) { //no params
        return "";
      }
      return pairs.join('&');
    };

    // Returns the url (minus old querystring, if any) with the given params (a dictionary) as a query string.
    FS.URL.setParams = function (url, params) {
      var parsedURL = FS.URL.parseURL(url),
        parsedParams = parsedURL.search,
        queryString = FS.URL.toQueryString(params);

      if (queryString.length === 0) {
        parsedURL.search = '';

        // remove ? if there are no more params
        parsedURL.href = parsedURL.href.replace('?', '');

        return parsedURL.href;
      }

      parsedURL.search = queryString;


      return parsedURL.href;
    };

    // Returns the url with the given params (a dictionary) appended to the current query string.
    FS.URL.appendParams = function (url, params) {
      var parsedURL = FS.URL.parseURL(url),
        parsedParams = parsedURL.search,
        queryString = FS.URL.toQueryString(params);

      if (queryString.length === 0) {
        return url;
      }


      if (parsedParams.length !== 0) {
        if (parsedURL.search[parsedURL.search.length - 1] === '&') {
          parsedURL.search = parsedURL.search.slice(0, -1);
        }

        parsedURL.search += '&' + queryString;
      } else {
        parsedURL.search = queryString;
      }

      return parsedURL.href;
    };

    // Returns the url with the given params (an array) removed from the current query string.
    FS.URL.removeParams = function (url, paramKeys) {
      if (paramKeys.length === 0) {
        return url;
      }

      var parsedURL = FS.URL.parseURL(url),
        parsedParams = FS.URL.parseParams(url),
        queryString;

      for (var i = 0; i < paramKeys.length; i++) {
        delete parsedParams[paramKeys[i]];
      }

      queryString = FS.URL.toQueryString(parsedParams);

      parsedURL.search = queryString;

      // remove ? if there are no more params
      if (parsedURL.search === '') {
        parsedURL.href = parsedURL.href.replace('?', '');
      }

      return parsedURL.href;
    };

    FS.qs = FS.URL.parseParams(window.location.search)
  }


  /*
   * Included File: experiments.js
   */
  if (typeof window.FS === "undefined") {
    window.FS = {};
  }
  /* EXPERIMENTS.JS */
  if (!FS.listEx && !FS.showEx && !FS.setEx) {

    /* global FS */
    (function (experiments) {
      var SHARED_KEY = 'shared-ui'
        , hostName = window.location.hostname.toLowerCase()
        , sharedExs = {}
        , localExs = {}
        , expDiv = null
        , appName = FS.appName || 'none'
        , EXPERIMENTS_COOKIE_NAME = 'fs_experiments'
        , EXPERIMENTS_COOKIE_NAME_APLPHA_SORT = 'fs_experiments_sort_alpha'
        , APP_EXPERIMENTS_COOKIE_NAME = 'fs_ex_' + appName
        , allExps = { apps: {} }
        , listOfExpNames //for search
        , expsTemplate
        , ONE_YEAR_IN_MS = 365 * 24 * 60 * 60 * 1000
        , initialized = false;


      /* Styles for DOM experiment list */
      var css = '#fs-experiment-list{z-index:9999;position:fixed;top:5px;left:5px;bottom:5px;background-color:#000000;padding:8px;width:325px;border-radius:5px;box-shadow:5px 10px 15px 0 #999;box-sizing:border-box;overflow:hidden}#fs-experiment-list header{overflow:auto;display:inline-block;margin-bottom:-5px}#fs-experiment-list header h4{color:#fff;padding:0;margin:0;cursor:pointer;font-weight:700;position:relative;padding-right:16px;}#fs-experiment-list header h4::after{ position: absolute;content:\'▼\';top:0;right:1px;font-size:10px;transform-origin:center;transform:rotate(-180deg);transition:all .1s ease-in-out}#fs-experiment-list header h4 span{font-size:10px}}#fs-experiment-list .tools:hover{text-decoration:underline}#fs-experiment-list .tools{float:right;padding-left:10px;text-decoration:none;color:#fff;font-size:15px}#fs-experiment-list .tools:nth-child(3) { margin-right:20px;}#fs-experiment-list section{position:absolute;top:92px;bottom:8px;left:8px;right:8px}#fs-experiment-list section > div{position:absolute;top:34px;bottom:0;right:0;left:0;border-radius:0 5px 5px;background-color:#fff;z-index:3}#fs-experiment-list section span{position:absolute;top:5px;cursor:pointer;padding:5px;background-color:#ddd;width:125px;height:45px;font-size:12px;font-weight:700;text-align:center;display:block;text-transform:uppercase;margin-top:0;transition:all .1s ease-in-out;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;z-index:1;box-sizing:border-box}#fs-experiment-list section span#css-tab-app{border-radius:3px 0 0}#fs-experiment-list section span#css-tab-app.selected{border-radius:3px 3px 3px}#fs-experiment-list section span#css-tab-shared{left:125px;z-index:2;border-radius:0 3px 0}#fs-experiment-list section span#css-tab-shared.selected{border-radius:3px 3px 3px}#fs-experiment-list section span.selected:hover{background-color:#fff}#fs-experiment-list section span.selected{top:0;background-color:#fff;border-radius:3px 3px 3px}#fs-experiment-list section span:hover{background-color:#ccc}#fs-experiment-list ul{list-style-type:none;margin:0;padding:8px;position:absolute;top:8px;bottom:8px;left:0;right:0;min-height:8px;overflow:auto}#fs-experiment-list section label:hover{color:#000}#fs-experiment-list section label{display:block;padding:0;font-size:14px}#fs-experiment-list section label input{margin:3px;top:-1px}#fs-experiment-list .hide_search{display:block}#fs-experiment-list #searchBox{width:100%;padding:5px 5px 5px 10px;margin:10px 0 20px;font-weight:700;border-radius:5px;border:0;font-size:14px;outline:0;background-color:#333333;color:#fff;box-sizing:border-box}#fs-experiment-list .close-experiments{position:absolute;top:12px;right:8px;font-weight:700;line-height:10px;color:#777777;text-decoration:none}#fs-experiment-list #pin-experiments{width:15px;height:15px;border-radius:50% 50% 50% 0;background:#584686;transform:rotate(-45deg);display:inline-block;float:right;margin:2px 5px 0 0}#fs-experiment-list #pin-experiments:after{content:"";width:6px;height:6px;border-radius:50px;display:inline-block;background-color:#fff;margin:0 0 5px 4px}#fs-experiment-list.collapsed{bottom:inherit;height:40px }#fs-experiment-list.collapsed header h4::after{transform:rotate(0deg);top:2px;right:0}',
        head = document.head || document.getElementsByTagName('head')[0],
        style = document.createElement('style');
        style.appendChild(document.createTextNode(css));

      head.appendChild(style);


      function deserializeExperiments(cookie, templates) {
        if (!(typeof (cookie) === 'string' && cookie.length)) return;

        if (cookie.indexOf('u=') === -1) return {};

        var userId = cookie.match(/u=[^,]+/)[0].replace('u=', '')
          , apps = cookie.split('&')
          , exps = { userId: userId }
          , appData = exps.apps = {};

        var setFeatures = function (app, template) {
          if (!template) return;
          var features = app.features = {}
            , values = app.values
            , dirty = app.dirtyFeatures = []
            , names = Object.keys(template);

          names.map(function (name, idx) {
            var value = values[idx] === '1'
              , origValue = !!template[name];

            features[name] = value;
          });
        };

        apps.map(function (item) {
          var app;
          try {
            var name = item.match(/a=[^,]+/)[0].replace('a=', '');

            app = appData[name] = {};

            if (name !== 'shared-ui' && name !== appName) {
              appData[name] = item;
              return;
            }

            app.stamp = item.match(/s=[^,]+/)[0].replace('s=', '');
            app.values = item.match(/v=[^,]+/)[0].replace('v=', '');
            setFeatures(app, (templates[name] || {}).features);
            delete app.values;
            app.bucket = item.match(/b=[^,]+/)[0].replace('b=', '');
            return app;
          } catch (e) {
            console.error('Old Experiment is bad');
          }
        });

        return exps;
      } // deserializeExperiments()

      function serializeExperiments(exps, username) {
        var contents = []
          , expApps = exps.apps || {}
          , expAppKeys = Object.keys(expApps);

        function serialize(appExps, appName) {
          // Not re-serializing other-app experiments
          if (typeof appExps === 'string') return appExps;

          var parts = ['a=' + (appName ? appName : '')]
            , features = appExps.features || {}
            , featureKeys = Object.keys(features);

          parts.push('s=' + appExps.stamp);
          var values = '';

          for (var i = 0; i < featureKeys.length; i++) {
            values += features[featureKeys[i]] ? '1' : '0';
          }
          parts.push('v=' + values);
          parts.push('b=' + appExps.bucket);
          return parts;
        }

        if (exps.apps) {
          for (var i = 0; i < expAppKeys.length; i++) {
            contents.push(serialize(expApps[expAppKeys[i]], expAppKeys[i]));
          }
        } else {
          contents.push(serialize(exps));
        }

        return 'u=' + username + ',' + contents.join('&');
      }

      function getExperimentsFromCookie() {
        var cookieString = FS.Cookie.getCookie(EXPERIMENTS_COOKIE_NAME) || ''
          , appCookieString = FS.Cookie.getCookie(APP_EXPERIMENTS_COOKIE_NAME) || ''
          , exps = {}
          , appExps = {};

        if (!(cookieString || appCookieString)) {
          return {};
        }

        if (!expsTemplate && window.manifest) {
          expsTemplate = window.manifest.experiments;
        }

        try {
          allExps = deserializeExperiments(cookieString, expsTemplate.apps);
        } catch (e) {
          allExps = { apps: {} };
        }

        allExps.apps[appName] = allExps.apps[appName] || appExps || { features: {} };
        allExps.apps[SHARED_KEY] = allExps.apps[SHARED_KEY] || { features: {} };

        return allExps.apps;
      }

      function setExperimentsCookie(exs, sharedExs) {
        var experiments = allExps
          , expireDateTime = new Date((new Date()).getTime() + (ONE_YEAR_IN_MS)) //set expiration date for 1 year
          , serialized;

        serialized = serializeExperiments(experiments, experiments.userId);
        FS.Cookie.setCookie(EXPERIMENTS_COOKIE_NAME, serialized, "/", expireDateTime);
      }

      function clearExperimentsCookie() {
        FS.Cookie.unsetCookie(EXPERIMENTS_COOKIE_NAME, "/");
        FS.Cookie.unsetCookie(APP_EXPERIMENTS_COOKIE_NAME, "/");
      }

      function setAlphabeticalSort() {
        FS.Cookie.setCookie(EXPERIMENTS_COOKIE_NAME_APLPHA_SORT, "1", "/");
        document.querySelector("body").removeChild(document.querySelector("#fs-experiment-list"));
        FS.listEx();
      }

      function unsetAlphabeticalSort() {
        FS.Cookie.unsetCookie(EXPERIMENTS_COOKIE_NAME_APLPHA_SORT, "/");
        document.querySelector("body").removeChild(document.querySelector("#fs-experiment-list"));
        FS.listEx();
      }

      function getClassNames(exs) {
        var classNames = [];
        if (exs) {
          for (var ex in exs.features) {
            if (!exs.features[ex]) {
              continue;
            }
            else if (typeof exs.features[ex] === 'boolean' || typeof exs.features[ex] === 'number') {
              classNames.push("ex_" + ex);
            } else {
              for (var vName in exs.features[ex]) {
                if (exs.features[ex][vName]) {
                  classNames.push("ex_" + ex + " ex_" + ex + "_" + vName);
                  break;
                }
              }
            }
          }
        }
        return classNames;
      }

      function addLines(container, exs, title) {

        function makeLine(name, value) {
          var li = document.createElement("li");
          li.id = name;
          li.setAttribute("class", "hide_search");
          var label = document.createElement("label");
          var input = document.createElement("input");
          input.type = "checkbox";
          input.value = name;
          if (value === "checked") {
            input.setAttribute("checked", value);
          }

          input.setAttribute("onclick", "javascript:FS.setEx('" + input.value + "', !FS.showEx('" + input.value + "'))");

          label.appendChild(input);
          label.innerHTML += "&nbsp;" + name;
          li.appendChild(label);

          container.appendChild(li);
        }

        var exName, exVal, keys = [];

        var callMakeLine = function (exName) {
          if (exs.features.hasOwnProperty(exName)) {
            exVal = exs.features[exName];

            if (typeof exVal === 'boolean' || typeof exVal === 'number') {
              makeLine(exName, exVal ? "checked" : "");
            } else {//object with variants
              for (var vName in exVal) {
                if (exVal.hasOwnProperty(vName)) {
                  makeLine(exName + "#" + vName, exVal[vName] ? "checked" : "");
                }
              }
            }
          }
        }

        if (FS.Cookie.getCookie(EXPERIMENTS_COOKIE_NAME_APLPHA_SORT) != undefined) {
          for (exName in exs.features) {
            callMakeLine(exName);
          }
        } else { // Sort based on the cookie
          Object.keys(exs.features || exs).sort().forEach(function (exName) {
            callMakeLine(exName);
          });
        }
      }

      /* Inits Experiments */
      FS.initEx = function () {
        getExperimentsFromCookie();

        var classNames = [];
        localExs = allExps.apps[appName] || (allExps.apps[appName] = {});
        sharedExs = allExps.apps[SHARED_KEY] || (allExps.apps[SHARED_KEY] = {});

        if (Object.keys(localExs).length === 0) { localExs.features = {} }
        if (Object.keys(sharedExs).length === 0) { sharedExs.features = {} }
        listOfExpNames = Object.keys(localExs.features).concat(Object.keys(sharedExs.features));

        /* Add classes to html tag for each experiment so css styles can be targeted */
        classNames = classNames.concat(getClassNames(localExs));
        classNames = classNames.concat(getClassNames(sharedExs));

        document.documentElement.className += " " + classNames.join(' ');

        /* Dispatch an event in case someone is listening */
        var evt = document.createEvent('HTMLEvents');
        evt.initEvent('ExReady', true, false);
        window.dispatchEvent(evt);

        initialized = true;
      }

      // Public Variables and Methods
      window.FS = Object.assign((typeof FS === "object" ? FS : {}), {

        defaultEx: function (template) {
          expsTemplate = template;
        },

        activeList: function () {
          var active = [],
              name;
          for (name in localExs.features) {
            if (FS.showEx(name)) {
              active.push(name);
            }
          }
          for (name in sharedExs.features) {
            if (FS.showEx(name)) {
              active.push(name);
            }
          }
          return active;
        },

        setEx: function (name, value) {
          console.log("Running setEX", name, value);
          value = value ? 1 : 0;
          var apps = allExps.apps
            , obj = (apps[appName].features || (apps[appName].features = {}))
            , sharedObj = (apps[SHARED_KEY].features || (apps[SHARED_KEY].features = {}))
            , toks = name.split('#');

          if (toks.length === 2) {
            if (sharedObj[toks[0]] !== undefined) {
              sharedObj = sharedObj[toks[0]] = sharedObj[toks[0]] || {};
            } else {
              obj = obj[toks[0]] = obj[toks[0]] || {};
            }

            name = toks[1];
          }

          // both the shared and app experiments must be in sync, otherwise, if an experiment
          // is in both lists you'll never be able to change it from listEx() or setEx()
          if (sharedObj[name] !== undefined) {//shared experiment
            sharedObj[name] = value;
            if (sharedExs.dirtyFeatures && sharedExs.dirtyFeatures.join(' ').indexOf(toks[0]) === -1) { //add feature name to dirtyFeature array if it's not already there
              sharedExs.dirtyFeatures.push(toks[0]);
            }
          }

          // unit tests do not populate the experiment object so we need to allow them to
          // dynamically set any experiment name. This prevents dynamically setting an
          // experiment in the app list if it already exists in the shared list
          if (obj[name] !== undefined || sharedObj[name] === undefined) {//app experiment
            obj[name] = value;
            if (localExs.dirtyFeatures && localExs.dirtyFeatures.join(' ').indexOf(toks[0]) === -1) { //add feature name to dirtyFeature array if it's not already there
              localExs.dirtyFeatures.push(toks[0]);
            }
          }

          setExperimentsCookie();
        },

        listEx: function () {
          /* If the modal is currently displayed, remove it. This makes it handy if you are calling FS.listEx() multiple times from the javascript console on the same page. */
          if (expDiv) {
            document.querySelector("body").removeChild(document.querySelector("#fs-experiment-list"));
            expDiv = null;
            return;
          }

          expDiv = document.createElement("div");
          expDiv.id = "fs-experiment-list";
          expDiv.innerHTML = "<header><h4>FS Experiments</h4></header>";


          /* CLOSE div */
          var closeDiv = document.createElement("a");
          closeDiv.href = "javascript: void(0);";
          closeDiv.setAttribute("class", "tools close-experiments");
          closeDiv.innerHTML = "x";
          closeDiv.onclick = function () {
            document.querySelector("body").removeChild(document.querySelector("#fs-experiment-list"));
            expDiv = null;
          }

          expDiv.appendChild(closeDiv);


          /* RESET div */
          var resetDiv = document.createElement("a");
          resetDiv.href = "javascript: void(0);";
          resetDiv.setAttribute("class", "tools");
          resetDiv.innerHTML = "Reset";
          resetDiv.onclick = function () {
            clearExperimentsCookie();
            window.location.reload();
          };

          expDiv.appendChild(resetDiv);


          /* SORT div */
          var sort_alphabetically = FS.Cookie.getCookie(EXPERIMENTS_COOKIE_NAME_APLPHA_SORT) != undefined;

          if (sort_alphabetically) {
            var unsetSort = document.createElement("a");
            unsetSort.href = "javascript: void(0);";
            unsetSort.setAttribute("class", "tools");
            unsetSort.setAttribute("style", "color:grey;");
            unsetSort.innerHTML = "A-z";
            unsetSort.onclick = function () {
              unsetAlphabeticalSort();
            };

            expDiv.appendChild(unsetSort);

          } else {
            var alphaSort = document.createElement("a");
            alphaSort.href = "javascript: void(0);";
            alphaSort.setAttribute("class", "tools");
            alphaSort.innerHTML = "A-z";
            alphaSort.onclick = function () {
              setAlphabeticalSort();
            };

            expDiv.appendChild(alphaSort);
          }


          /* Pin Experiments */
          var pinDiv = document.createElement("a");
          pinDiv.href = "javascript: void(0);";
          pinDiv.id = "pin-experiments";
          pinDiv.onclick = function () {
            if (FS.sessionStorage.get("fs-experiments-sticky")) {
              FS.sessionStorage.remove("fs-experiments-sticky");
              document.querySelector("#pin-experiments").style.backgroundColor = "#777777";
            } else {
              FS.sessionStorage.set("fs-experiments-sticky", { state: "show" });
              document.querySelector("#pin-experiments").style.backgroundColor = "#87B940";
            }
          }

          expDiv.appendChild(pinDiv);


          /* Search Box */
          var searchBox = document.createElement("input");
          searchBox.id = "searchBox";
          searchBox.placeholder = "search";
          searchBox.style.display = "block"; //so we can hide it later

          searchBox.onkeyup = function () {
            var search_results = [];
            var search_filter = document.querySelector("#searchBox").value.toLowerCase();

            listOfExpNames.map(function (e) {
              if (e.toLowerCase().indexOf(search_filter) !== -1) {
                search_results.push(e);
              }
            })

            /* First hide everything */
            if (search_filter.length > 0) {
              var all = document.querySelectorAll(".hide_search");

              for (var i = 0, j = all.length; i < j; i++) {
                all[i].style.display = "none";
              }
            }

            /* Show experiments found */
            search_results.map(function (e) {
              document.querySelector("#" + e).style.display = "block";
            });
          }

          expDiv.appendChild(searchBox);


          /* Experiment section */
          expSection = document.createElement("section");
          expSection.style.display = "block";

          if (sharedExs) {
            createExperimentGroup(sharedExs, "Shared");
          }

          if (localExs) {
            createExperimentGroup(localExs, appName.charAt(0).toUpperCase() + appName.slice(1)); //TODO: Add sanitation
          }

          // Prevent the experiments list from scrolling the document
          FS.Helpers.preventParentScroll(expDiv);

          // Append experiment div to body
          expDiv.appendChild(expSection);

          document.body.insertBefore(expDiv, document.body.childNodes[0]);




          /* CUSTOMIZE Experiment list based on session storage */
          if (FS.sessionStorage.get("fs-experiments-sticky")) {
            document.querySelector("#pin-experiments").style.backgroundColor = "#87B940";

            if (FS.sessionStorage.get("fs-experiments-sticky").state === "hide") {
              clickHeader();
            }
          } else {
            document.querySelector("#pin-experiments").style.backgroundColor = "#777777";
          }

          function clickHeader() {
            var expList = document.querySelector("#fs-experiment-list");
            var className = expList.className || '';
            if (className.includes('collapsed')) {
              expList.className = className.replace('collapsed', '').trim();
              FS.sessionStorage.set("fs-experiments-sticky", { state: "show"});
            } else {
              expList.className = className + ' collapsed';
              FS.sessionStorage.set("fs-experiments-sticky", { state: "hide"});
            }
          }

          // toggle experiment list
          document.querySelector("#fs-experiment-list header").onclick = clickHeader;

          if (FS.sessionStorage.get("fs-experiments-tab")) {
            document.querySelector("#css-tab-shared").click();
          } else {
            document.querySelector("#css-tab-app").click();
          }

          function createExperimentGroup(groupExps, appName) {
            var span = document.createElement("span");
            span.id = (appName === "Shared") ? "css-tab-shared" : "css-tab-app";
            span.innerHTML = appName;

            expSection.insertBefore(span, expSection.firstChild);
            // expSection.appendChild(span)

            var scrollContainer = document.createElement("div");
            scrollContainer.id = (appName === "Shared") ? span.id + "-content" : span.id + "-content";
            expSection.appendChild(scrollContainer);
            var groupContainer = document.createElement("ul");
            groupContainer.style.display = "block";
            scrollContainer.appendChild(groupContainer);

            span.onclick = function () {
              toggleLists(scrollContainer.id);
            };

            addLines(groupContainer, groupExps);
          }

        },

        showEx: function (name, defaultValue) {
          if (!initialized) FS.initEx();
          if (name === null || name.length === 0) {
            return true;
          }

          if (defaultValue === undefined) {
            defaultValue = false;
          }

          var obj = (localExs.features || (localExs.features = {})),
              sharedObj = (sharedExs.features || (sharedExs.features = {})),
              toks = name.split('#'),
              appResult = false,
              sharedResult = false;

          if (toks.length === 2) {
            if (sharedObj[toks[0]] !== undefined) {
              sharedObj = sharedObj[toks[0]] = sharedObj[toks[0]] || {};
            } else {
              obj = obj[toks[0]] = obj[toks[0]] || {};
            }
            name = toks[1];
          }

          if ((obj[name] === undefined) && (sharedObj[name] === undefined)) {
            return defaultValue;
          }

          appResult = obj[name] ? true : false;//TODO: This will need to change to return variant names
          sharedResult = sharedObj[name] ? true : false;//TODO: This will need to change to return variant names

          if (appResult) {
            return appResult;
          } else {
            return sharedResult;
          }
        }
      });

      var arrows = {
        down: "&#x25BC;",
        left: "&#x25C0;"
      };

      function toggleLists(name) {
        document.querySelector("#" + name).style.display = "block";
        if (name === "css-tab-shared-content") {
          FS.sessionStorage.set("fs-experiments-tab", "shared");
          document.querySelector("#css-tab-app-content").style.display = "none";
          document.querySelector("#css-tab-shared").setAttribute("class", "selected");
          document.querySelector("#css-tab-app").setAttribute("class", "");
        } else {
          FS.sessionStorage.remove("fs-experiments-tab");
          document.querySelector("#css-tab-shared-content").style.display = "none";
          document.querySelector("#css-tab-app").setAttribute("class", "selected");
          document.querySelector("#css-tab-shared").setAttribute("class", "");
        }
      }

      //Initialization Code
      document.addEventListener("DOMContentLoaded", function () {
        var exsFromGlobalNamespace = typeof experiments == "object" ? experiments : {}; //base experiment list off of global 'experiments' variable, if it exists

        //Although exsFromGlobalNamespace is passed into FS.initEx, it is never used.
        if (!initialized) FS.initEx(exsFromGlobalNamespace);

        // if expDiv is not null, experiments have already been initialized
        if (FS.qs.listEx && expDiv === null || FS.sessionStorage.get("fs-experiments-sticky")) {
          FS.listEx();
        }
      });
    })(window.experiments);
  }


  /*
   * Included File: safe-html.js
   */
  if (typeof FS === "undefined") {
    FS = {};
  }
  /**
   * Encode html entities.
   * @param {string} text
   * @returns {string}
   */
  FS.htmlEncode = FS.htmlEncode || function (text) {
    if (!text) return '';

    var tagsToReplace = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      '\'': '&#39;',
      ' ': '&nbsp;'  // \xA0 character
    };

    return text.replace(/[&<>"'\xA0]/g, function (tag) {
      return tagsToReplace[tag];
    });
  };

  /**
   * Safely decode html entities.
   * @see https://stackoverflow.com/a/34064434/2124254
   *
   * @param {string} text
   * @returns {string}
   */
  FS.htmlDecode = FS.htmlDecode || function (text) {
    if (!text) return '';

    var doc = new DOMParser().parseFromString(text, "text/html");
    return doc.documentElement.textContent;
  };


  /*
   * Included File: storage.js
   */
  if (typeof FS === "undefined") {
    FS = {};
  }
  if (!FS.localStorage) {

    // TODO: make this defered.
    (function (FS) {
      /* local and session Storage helper functions on the FS object. */
      FS.localStorage = {};
      FS.sessionStorage = {};

      var SUPPORTED = (typeof Storage !== 'undefined'),
        PREFIX = 'FS';

      //iOS 7 Private Browsing still has storage functions available, but any attempt to use them will throw a JavaScript error: "QuotaExceededError: DOM Exception 22: An attempt was made to add something to storage that exceeded the quota."
      try { localStorage.test = 0; } catch (e) {
        SUPPORTED = false;
      }

      var apis = [
        // simple/empty will not use any user id to make the key.
        // Intended to be used for all users.
        {
          name: '',
          keyMaker: makeSimpleKey
        },
        // UserData will use the helper id or the logged-in user id to make the key.
        {
          name: 'UserData',
          keyMaker: makeUserKey
        },
        // RealUserData will only use the logged-in user id to make the key.
        {
          name: 'RealUserData',
          keyMaker: makeRealUserKey
        }
      ];

      var storageNames = ['localStorage', 'sessionStorage'];

      // create
      // FS.localStorage.set
      // FS.localStorage.setUserData
      // ...
      // FS.sessionStorage.get
      // FS.sessionStorage.getUserData
      // ...
      for (var i = 0; i < storageNames.length; i++) {
        var storageName = storageNames[i];

        (function (storageName) {
          for (var j = 0; j < apis.length; j++) {
            var api = apis[j];

            (function (api) {
              FS[storageName]['set' + api.name] = function (key, value) {
                return addToStorage(storageName, api.keyMaker, key, value);
              }

              FS[storageName]['get' + api.name] = function (key, parseBoolean) {
                return getFromStorage(storageName, api.keyMaker, key, parseBoolean);
              }

              FS[storageName]['remove' + api.name] = function (key) {
                return removeFromStorage(storageName, api.keyMaker, key);
              }
            })(api);
          }

          FS[storageName]['moveToUserData'] = function (key) {
            return moveToUserData(storageName, key);
          }

          FS[storageName]['clear'] = function () {
            if (!SUPPORTED) { return; }
            window[storageName].clear();
          }
        })(storageName);
      }


      // utils

      function hashCode(str) {
        var ret = 0;
        for (var i = 0, len = str.length; i < len; i++) {
          ret = (31 * ret + str.charCodeAt(i)) << 0;
        }
        return ret;
      }

      function makeKey(key, userIdGetter) {
        if (!key) return null;
        if (userIdGetter) {
          var userId = userIdGetter();
          if (!userId) return null;
          key += '-' + hashCode(userId);
        }
        return PREFIX + '.' + key;
      }

      function makeSimpleKey(key) {
        return makeKey(key);
      }

      function makeUserKey(key) {
        return makeKey(key, FS.User.getEffectiveId);
      }

      function makeRealUserKey(key) {
        return makeKey(key, FS.User.getId);
      }

      function moveToUserData(storageName, key) {
        var userId = FS.User.getEffectiveId();
        if (!userId) return;
        var value = getFromStorage(storageName, makeSimpleKey, key);
        if (value) {
          addToStorage(storageName, makeUserKey, key, value);
          removeFromStorage(storageName, makeSimpleKey, key);
        }
      }

      function addToStorage(storageName, keyMaker, key, value) {
        if (!SUPPORTED) { return; }

        key = keyMaker(key);
        if (!key) return;

        if (typeof value === "undefined") {
          value = null;
        }

        if (Array.isArray(value) || value === Object(value)) {
          value = JSON.stringify(value);
        }

        window[storageName].setItem(key, value);

        return true;
      }

      function getFromStorage(storageName, keyMaker, key, parseBoolean) {
        if (!SUPPORTED) { return null; }

        key = keyMaker(key);
        if (!key) return null;

        var item = window[storageName].getItem(key) || null;

        if (!item || item === 'null') {
          return null;
        }

        if (item.charAt(0) === "{" || item.charAt(0) === "[") {
          return JSON.parse(item);
        }

        //This is to parse booleans in a non breaking way for any clients that may rely on it not being parsed
        if (parseBoolean && (item === "true" || item === "false")) {
          return JSON.parse(item);
        }

        return item;
      }

      function removeFromStorage(storageName, keyMaker, key) {
        if (!SUPPORTED) { return; }

        /// if valid session, remove proper key:val
        if (FS.User.profile) {
          window[storageName].removeItem(keyMaker(key));

          // else remove all with base of key
        } else {
          for (var i = 0, j = window[storageName].length; i < j; i++) {
            var value = window[storageName].key(i);
            if (value && value.indexOf("FS." + key) !== -1) {
              window[storageName].removeItem(value);
            }
          }
        }

        return true;
      }

    })(window.FS);
  }


  /*
   * Included File: i18n.js
   */
  if (typeof FS === "undefined") {
    FS = {};
  }

  /**
   * Get the current language translation. This function is a simple stub for TaaS
   * that should only be used by native web components.
   * @param {string} key
   */
  FS.i18n = FS.i18n || function (key) {
    if (!this.taasContent) return '[' + key + ']';

    var locale = FS.simpleLocale() || 'en';

    // locale=zz returns the TaaS key in brackets
    if (locale === 'zz') {
      return '[' + key + ']';
    }
    // locale=ke returns just the last part of the key. useful for ensuring there are
    // no hard-coded strings while not polluting the interface with really long key
    // names
    else if (locale === 'ke') {
      var keyParts = key.split('.');
      return '[' + keyParts[keyParts.length - 1] + ']';
    }

    // when we don't have locale data from the server we can only fallback to
    // navigator.languages with the current locale at the front of the list and
    // 'en' as the last of the list
    var locales = FS.locale;
    if (!locales) {

      // make sure we're using a new reference and not changing navigator.languages
      locales = [].concat(window.navigator.languages || []);
      locales.unshift(locale);
      locales.push('en');
    }

    var keyList = key.split('.');

    for (var localeIndex = 0; localeIndex < locales.length; localeIndex++) {
      var lang = locales[localeIndex];

      // keep splitting sublocales off the lang until we find a supported one
      while (!this.taasContent[lang] && lang.indexOf('-') !== -1) {
        lang = lang.substring(0, lang.lastIndexOf('-'));
      }

      if (this.taasContent[lang]) {
        var translation = this.taasContent[lang];

        for (var i = 0; i < keyList.length; i++) {

          // if the key is not found then move to the next locale
          if (!translation[keyList[i]]) {
            break;
          }

          translation = translation[keyList[i]];
        }

        // translation found
        if (i === keyList.length) {
          return translation;
        }
      }
    }

    // translation not found
    return '[' + key + ']';
  };
  /**
   * Function only used by native web components to add translations to taasContent.
   * @param {object} translations - flat translation object
   */
  FS._registerTranslations = function (translations) {
    FS.taasContent = FS.taasContent || {};

    Object.keys(translations).forEach(function (lang) {
      FS.taasContent[lang] = FS.taasContent[lang] || {};

      Object.keys(translations[lang]).forEach(function (key) {
        var keyParts = key.split('.');
        var taasContent = FS.taasContent[lang];

        // don't parse the last part of the key
        for (var i = 0; i < keyParts.length - 1; i++) {
          taasContent[keyParts[i]] = taasContent[keyParts[i]] || {};
          taasContent = taasContent[keyParts[i]];
        }

        var lastKey = keyParts[keyParts.length - 1];
        taasContent[lastKey] = taasContent[lastKey] || translations[lang][key];
      });
    });
  };

  /*
   * Included File: user.js
   */
  if (typeof FS === "undefined") {
    FS = {};
  }

  let promises = {
    isMemberPromise: null,
    templePermissionPromise: null,
    templePrefPromise: null,
    currentUserPromise: null,
    segmentDataPromise: null
  };

  function getPermissionPromise(promiseName, permissionCacheKey, permissionName) {
    if (promises[promiseName]) {
      return promises[promiseName];
    }

    const permissionCache = FS.sessionStorage.getUserData(permissionCacheKey);

    if (permissionCache) {
      promises[promiseName] = Promise.resolve(permissionCache.authorized);
    } else {
      promises[promiseName] = FS.User.hasCasPermission(permissionName).then(permission => {
        FS.sessionStorage.setUserData(permissionCacheKey, {authorized: permission});
        return permission;
      }, err => {
        throw new Error('Bad response from CAS: ' + err.toString());
      });
    }
    return promises[promiseName];
  }

  /* Public functions */
  FS.User = Object.assign({
    /* Returns the ID of the logged-in user */
    getId: function () {
      if (!FS.User.profile) {
        return null;
      }
      return FS.User.profile.cisId;
    },

    /* Returns the ID of the effective user (In helper mode, helper ID - else user ID */
    getEffectiveId: function () {
      if (!FS.User.profile) {
        return null;
      }
      if (!FS.User.helper) {
        return FS.User.profile.cisId;
      }
      return FS.User.helper.cisId;
    },
    /* Get the context for a CAS permission call for the user.
    * @param {string} contextName - Optional. Name of the CAS context key. Defaults to FamilyTree if not provided
    * @param {string} defaultContextValue - Optional. Value of the context if the user is not in an elevated role. Defaults to FtNormalUserContext if not provided
    * */
    getCasContext: function (contextName, defaultContextValue) {
      contextName = contextName || 'FamilyTree';
      defaultContextValue = defaultContextValue || 'FtNormalUserContext';

      if (FS.User.session && FS.User.session.values && FS.User.session.values.length) {
        var session = FS.User.session;
        for (var i = 0; i < session.values.length; i++) {
          if ((session.values[i].restricted === true) && (session.values[i].name === contextName)) { // the context name will only be in the user's session if the user is in an elevated role
            return session.values[i].value;
          }
        }
      }
      return defaultContextValue; // if the user is not in an elevated role, return the default value for the context
    },
    /* See if the user has a particular CAS permission in the context the user is in.
     * @param {string} permissionName - Required. Name of the permission to check CAS for
     * @param {string} contextName - Optional. Name of the CAS context key. Defaults to FamilyTree if not provided
     * @param {string} defaultContextValue - Optional. Value of the context if the user is not in an elevated role. Defaults to FtNormalUserContext if not provided
    * */
    hasCasPermission: function (permissionName, contextName, defaultContextValue) {
      if (!permissionName) {
        return Promise.reject(new Error("Missing required parameter: permissionName"));
      }

      const sessionId = FS.User.sessionId;

      const url = FS.baseUrl + "/service/ident/cas/cas-public-api/authorization/v1/authorize?perm=" +
        permissionName +
        "&context=" +
        FS.User.getCasContext(contextName, defaultContextValue) +
        "&sessionId=" +
        sessionId;
      return FS.fetch(url).then(res => {
        return res.authorized;
      }, err => {
        throw new Error('Bad response from CAS: ' + err.toString());
      });
    },

    /* Returns user data from /platform/users/current */
    getCurrentUser: function (cb) {

      var realUserCache = FS.sessionStorage.getRealUserData("currentUser"),
        usePromise = !cb;

      if (promises.currentUserPromise && usePromise) {
        return promises.currentUserPromise;
      } else if (promises.currentUserPromise && cb) {
        promises.currentUserPromise.then(function(data) {
          cb(null, data);
        }, function(err) {
          cb(err);
        });
      }

      promises.currentUserPromise = new Promise(function (resolve, reject) {
        function finish(value, err) {
          if (usePromise) {
            if (err) {
              reject(err);
            } else {
              resolve(value);
            }
          } else {
            if (err) {
              cb(err);
            } else {
              cb(null, value);
            }
          }
        }

        function getUserFromServer() {
          var url = FS.baseUrl + "/platform/users/current";

          FS.fetch(url).then(res => {
            FS.sessionStorage.setRealUserData("currentUser", res);
            finish(res);
          }, err => {
            finish(undefined, new Error('Bad response from tree-data: ' + err));
          });
        }

        // delete temple pref if session expires
        if (realUserCache) {
          finish(realUserCache);
        } else {
          getUserFromServer();
        }
      });

      return usePromise ? promises.currentUserPromise : false;
    },

    getTemplePref: function (cb) {
      var templeInfoKey = 'fs-templeinfo',
        sessionId = FS.User.sessionId,
        templeInfoCache = FS.sessionStorage.getUserData(templeInfoKey),
        usePromise = !cb;

      if (promises.templePrefPromise && usePromise) {
        return promises.templePrefPromise;
      } else if (promises.templePrefPromise && cb) {
        promises.templePrefPromise.then(function (data) {
          cb(data);
        }, function (err) {
          cb(false);
        });
      }

      promises.templePrefPromise = new Promise(function (resolve, reject) {
        function finish(value, err) {
          if (usePromise) {
            if (err) {
              reject(err);
            } else {
              resolve(value);
            }
          } else {
            cb(value);
          }
        }

        function getPrefFromServer() {
          var url = FS.baseUrl + "/service/tree/tree-data/profile/pref/showLDSTempleInfo?_q=" + new Date().getTime() + "&fsSessionId=" + sessionId;

          FS.fetch(url).then(res => {
            var pref = res || {};

            if (pref.data !== null) {
              pref = pref.data.replace(/\&quot;/g, '"') || {};
              pref = JSON.parse(pref);
            } else if (pref.pref === null) {
              pref.pref = true;// if the user has not changed his preference and he is a member, it's possible that the pref is null. Set to true
            }

            if (typeof pref.pref !== "undefined") {
              FS.sessionStorage.setUserData(templeInfoKey, {pref: pref.pref});
            }

            finish(pref.pref);
          }, err => {
            finish(undefined, new Error('Bad response from tree-data: ' + err));
          });
        }

        // delete temple pref if session expires
        if (!sessionId) {
          FS.sessionStorage.removeUserData(templeInfoKey);
          finish(false);
        } else if (templeInfoCache && typeof templeInfoCache.pref !== "undefined" && templeInfoCache.pref !== null) {
          finish(templeInfoCache.pref);
        } else {
          getPrefFromServer();
        }
      });

      return usePromise ? promises.templePrefPromise : false;
    },

    getSegmentData: function () {
      if (promises.segmentDataPromise) return promises.segmentDataPromise;

      promises.segmentDataPromise = new Promise(function (resolve, reject) {
        if (!FS.User.getEffectiveId()) {
          reject(new Error('no user id'));
          return;
        }

        var url = '/service/home/pb/users/' + FS.User.getEffectiveId() + '/segment';
        var headers = [['Accept', 'application/json'], ['Authorization', 'Bearer ' + FS.User.sessionId]];
        FS.xhr("GET", url, headers, null, function (res) {
          if (res.status === 200) {
            var segmentData = JSON.parse(res.response);
            resolve(segmentData);
          }
          else {
            reject(new Error('bad response status=' + res.status));
          }
        });
      });
      return promises.segmentDataPromise;
    },

    hasMemberPermission: function () {
      // WARNING - hasMemberPermission is not a secure function. Anybody could change the session storage and make this function return true.;
      return getPermissionPromise("isMemberPromise", 'fs-memberPermission', 'FtMemberUiPermission');
    },

    hasTemplePermission: function () {
      // WARNING - hasTemplePermission is not a secure function. Anybody could change the session storage and make this function return true.;
      return getPermissionPromise("templePermissionPromise", 'fs-templePermission', 'ViewTempleUIPermission');
    },

    shouldSeeTempleInfo: function () {
      // Do not use this function to show sensitive data. It uses browser caches that could be altered by users

      return Promise.all([FS.User.getTemplePref(), FS.User.hasTemplePermission()]).then(function (checks) {
        return checks[0] && checks[1];
      });
    },
    /* only use this function for unit testing */
    setPromiseUnitTestingOnly : function (promiseName, value) {promises[promiseName] = value;}

  }, typeof FS.User === "object" ? FS.User : {});


  /*
   * Included File: xhr.js
   */
  if (typeof FS === "undefined") {
    FS = {};
  }

  /* Simple XHR request wrapper with callback */
  FS.xhr =  FS.xhr || function (method, url, headers, data, cb) {
    var xmlhttp = new XMLHttpRequest();
    xmlhttp.open(method, url, true);
    xmlhttp.onreadystatechange = function () {
      if (xmlhttp.readyState == XMLHttpRequest.DONE) {
        if (cb) cb(xmlhttp);
      }
    }
    if (headers) {
      for (var i = 0, j = headers.length; i < j; i++) {
        xmlhttp.setRequestHeader(headers[i][0], headers[i][1]);
      }
    }
    xmlhttp.send(data);
  };

  /* Fetches a JS file and loads it into the head async */
  FS.fetchScript = FS.fetchScript || function (url, cb) {
    if (!document.querySelector('script[src="' + url + '"]')) {
      var script = document.createElement('script')
        , head = document.getElementsByTagName('head')[0];

      script.setAttribute('src', url);
      script.onload = function () {
        if (cb) cb();
      };

      head.insertBefore(script, head.firstChild);
      console.info("Fetching script", url);
    } else {
      if (cb) cb();
    }
  };


})(window, document, window.FS);
